import { render, staticRenderFns } from "./Not-found.vue?vue&type=template&id=59addf66&scoped=true"
import script from "./Not-found.vue?vue&type=script&lang=js"
export * from "./Not-found.vue?vue&type=script&lang=js"
import style0 from "./Not-found.vue?vue&type=style&index=0&id=59addf66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59addf66",
  null
  
)

export default component.exports